import PropTypes from "prop-types";

import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";
import { ProductVariantNameCell } from "@/features/ui";

// Read-only mirror of what the store declared. Quantities are not editable
// here: conversion always mirrors the return 100%, and the backend takes no
// line payload at all, so an editable grid would promise something the API
// cannot honour.
export const ProductVariantsSection = ({ purchaseReturnProductVariants }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Barang yang Diretur</Typography>
        <DataGrid
          getRowHeight={() => "auto"}
          rows={purchaseReturnProductVariants ?? []}
          disableRowSelectionOnClick
          hideFooter
          columns={[
            {
              field: "name",
              headerName: "Produk Varian",
              flex: 5,
              renderCell: ({ row: { name, sku } }) => (
                <ProductVariantNameCell name={name} sku={sku} linkToStock />
              ),
            },
            {
              field: "quantity",
              headerName: "Qty",
              type: "number",
              flex: 1,
              valueFormatter: (value) => formatNumber(value),
            },
            {
              field: "unitOfMeasurement",
              headerName: "Unit",
              flex: 1,
              valueGetter: (_, row) =>
                row.product?.unitOfMeasurement?.name || "-",
            },
            {
              field: "note",
              headerName: "Catatan",
              flex: 1.5,
              valueGetter: (_, row) => row.note || "-",
            },
          ]}
          initialState={{
            sorting: { sortModel: [{ field: "name", sort: "asc" }] },
          }}
        />
      </Stack>
    </Paper>
  );
};

ProductVariantsSection.propTypes = {
  purchaseReturnProductVariants: PropTypes.array,
};
